import React from 'react';
import { Automations, History } from '@fabric-ui/icons';
import { RelativeDatePeriod, RelativeDateType } from '../../../../components/DatePicker/AvDateRangePicker.constants';
import { RelativeUnit } from '../../../../components/DatePicker/utils';

export const TimeframeOptions = {
  current: { value: 'Current', icon: <Automations /> },
  historic: { value: 'Historical', icon: <History /> },
};

export const dateFormat = 'MMM dd, yy';

export const newDefaultTimeRange = {
  value: {
    relative: {
      unit: RelativeUnit.DAYS,
      value: 30,
      periodBehaviour: RelativeDateType.last,
    },
  },
  preset: {
    count: 30,
    period: RelativeDatePeriod.days,
    type: RelativeDateType.last,
  },
};
